export default "__VITE_ASSET__CnZ98EVr__"